import { SelectOption } from '@frontend/components/basic-forms';
import { TransactionEnumClient } from '@frontend/transaction/api';
import { TransactionState, TransactionStateName } from '@frontend/transaction/types';
import { useEffect, useState } from 'react';

import { TransactionStateSelectV2Props } from './transaction-state-select.component';

interface ViewProps {
    options: SelectOption<TransactionStateName>[];
}

const useTransactionStateSelect = (props: TransactionStateSelectV2Props): ViewProps => {
    const [options, changeOptions] = useState<SelectOption<TransactionStateName>[]>([]);

    useEffect(() => {
        TransactionEnumClient.fetchTransactionStates().then((states) => {
            return changeOptions(
                states
                    .filter((state) => (props.subset ? props.subset.includes(state) : true))
                    .map((state) => {
                        const found = TransactionState.ALL.find((t) => t.value === state);
                        if (found) {
                            return {
                                value: found.value,
                                label: found.value,
                                display: found.displayName
                            };
                        } else
                            return {
                                value: state,
                                label: state.replace(/_/g, ' ')
                            };
                    })
            );
        });
    }, []);

    return { options };
};

export default useTransactionStateSelect;
